"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SkipLink = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Skip link](https://vanillaframework.io/docs/patterns/links#skip-link) component.
 */
const SkipLink = _ref => {
  let {
    mainId = "main-content"
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "p-link--skip",
    href: "#".concat(mainId)
  }, "Skip to main content");
};
exports.SkipLink = SkipLink;
SkipLink.propTypes = {
  mainId: _propTypes.default.string
};
var _default = exports.default = SkipLink;